<div class="justify-content-between">
    <h2>Page not found</h2>
    <button class="btn btn-primary" (click)="goBack()">Go Back</button>
</div>